export default __webpack_public_path__ + "static/media/taporty-video.7755070c.mp4";